import React, { Component } from 'react';
import { Button, Card, Image, Icon, Container, Grid, Message, List } from 'semantic-ui-react'
import printerImage from '../../printer_svg.svg'
import { Link } from 'react-router-dom';
import TimeAgo from 'react-timeago'


import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export default class MainMenu extends Component {
    constructor(props) {
        super(props)
    }

    goToNewOrder = () => {
        history.push('/newOrder')
    }

    render() {

        const orderListHolder = (
            <List divided relaxed>
                {userOrderUiList}
            </List>
        )

        // const userOrderUiList = (
        //     <List.Item>
        //         <List.Icon name='github' size='large' verticalAlign='middle' />
        //         <List.Content>
        //             <List.Header as='a'>status</List.Header>
        //             <List.Description as='a'>Updated 10 mins ago</List.Description>
        //         </List.Content>
        //     </List.Item>
        // );

        const userOrderUiList = this.props.usersOrders.map((order) =>
            <List.Item key={order.dateNum}>
                <List.Icon name='print' size='large' verticalAlign='middle' />
                <List.Content>
                    <List.Header as='a'>STATUS: {order.status}</List.Header>
                    <List.Description as='a'>
                    <TimeAgo date={order.dateNum} />
                    </List.Description>
                    <List.Description as='a'>
                    {order.usersFileName}
                    </List.Description>
                </List.Content>
            </List.Item>
        );

        return (
            <Container>

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Card.Group >
                                <Card centered>
                                    <Image src={printerImage} />
                                    <Card.Content>
                                        <Card.Header>
                                            {/* <Link to="/newOrder">CREATE NEW ORDER</Link> */}
                                            <Button onClick={this.goToNewOrder}>
                                                CREATE NEW ORDER
                                            </Button>
                                        </Card.Header>
                                    </Card.Content>
                                </Card>
                            </Card.Group>
                            <Button onClick={this.props.logOutFunction}>
                                Logout
                            </Button>
                        </Grid.Column>
                        {/* <Grid.Column width={8}>
                            <Message
                                icon='inbox'
                                header={'You have ' + this.props.usersOrders.length + ' orders'}
                                content=''
                            />

                            <List divided relaxed>
                                {userOrderUiList}
                            </List>

                        </Grid.Column> */}
                    </Grid.Row>
                </Grid>


            </Container>
        )
    }

}

// const MainMenu = (props) => (
//     <Container>
//         <Card.Group >
//             <Card centered>
//                 <Image src={printerImage} />
//                 <Card.Content>
//                     <Card.Header>
//                         <Link to="/newOrder">CREATE NEW ORDER</Link>
//                     </Card.Header>
//                 </Card.Content>
//             </Card>
//         </Card.Group>
//         <Button onClick = {props.logOutFunction}>
//             Logout
//         </Button>
//     </Container>

// )

//export default MainMenu


// WEBPACK FOOTER //
// ./src/components/Menus/MainMenu.js